import { Component } from '@angular/core';

@Component({
    selector: 'app-sales-shell',
    templateUrl: './shell.component.html',
    styleUrls: ['./shell.component.scss'],
})
export class ShellSalesComponent {}
